import React, { useEffect, useState } from "react";
import withRouter from "../../withRouter";
import Menu from "../../Component/Menu";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import { spin } from "../../Common/NewLoader";
import { Link } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import MUIDataTable from "mui-datatables";
import CustomToolbar from "../../CommonComponents/CustomToolbar";
import moment from "moment";
import ProjectManagementServices from "../ProjectManagementServices";
import { currentTenant } from "../../Common/Credentials";
import FormControlLabel from "@mui/material/FormControlLabel";
import IOSSwitch from "../../CommonComponents/IOSSwitch";

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, 'solid', '#ece6e6']],
      },
      body:
      {
        border: [[1, 'solid', '#ece6e6']],
      },
    },
  },
});

const ProjectStoreTable = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    ProjectManagementServices.FindAllStore(currentTenant)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const columns = [
    { name: "itemId", label: "Id", options: { filter: false, sort: false, display: false } },
    { name: "customid", label: "Item Id", options: { filter: true, sort: true } },
    { name: "itemName", label: "Item Name", options: { filter: true, sort: true } },
    { name: "itemCode", label: "Item Code", options: { filter: true, sort: true } },
    { name: "Quantity", label: "", options: { filter: true, sort: true } },
    {
      name: "createdAt",
      label: "Date",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD-MM-yyyy hh:mm"),
      },
    },
    {
      name: "View",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <Link
              as="button"
              data-tip
              data-for="edit"
              className="fa fa-list-alt"
              to={{
                pathname: `/project/${tableMeta.rowData[0]}`,
              }}
            ></Link>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    customToolbar: () => {
      return (
        <Link
          as="button"
          className="float-right btn btn-sm m-0 p-0"
          to={{ pathname: "/projectstorenewitem", state: { id: -1, pagename: "New Item Creation" } }}
        >
          <CustomToolbar />
        </Link>
      );
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    downloadOptions: {
      filename: "Projects.csv",
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card card-info">
          <ol className="breadcrumb float-sm-right">
            <li className="breadcrumb-item text-secondary">
              <Link to="/projectmanagement">Home</Link>
            </li>
            <li className="breadcrumb-item active">Store</li>
          </ol>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card-body">
                    {/* <div className="card-header">
                      <h3 className="card-title"> Store </h3>
                    </div> */}

                    <div>
                      {loading ? (
                        <div className="text-center">{spin}</div>
                      ) : (

                        <div className="form-group col-md-12">
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm"
                              title={"Items"}
                              data={data}
                              columns={columns}
                              options={options}
                            />
                          </ThemeProvider>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>

  );
};
export default withRouter(ProjectStoreTable);
